module.exports = __webpack_public_path__ + "static/media/defrag_7.d4687a3a.ico";